// UandAI™ — Icon set (SVG, replaces emoji)
// Resh Consultancy LLC · Vijay Anand Raj Kanaparthy · John 14:26
// Stroke icons inherit the surrounding text color via currentColor, the way the emoji did.

import React from "react";

const P = {
  // status
  check:   "M4 12.5l5 5L20 6",
  checkCircle: "M8 12.5l2.5 2.5L16 9 M12 3a9 9 0 100 18 9 9 0 000-18z",
  x:       "M6 6l12 12 M18 6L6 18",
  warning: "M12 3L2 20h20L12 3z M12 10v4 M12 17h.01",
  block:   "M12 3a9 9 0 100 18 9 9 0 000-18z M6 6l12 12",
  dot:     "M12 7a5 5 0 100 10 5 5 0 000-10z",
  verified:"M12 3l2.5 2 3-.3 1 2.8 2.5 1.7-1 2.8 1 2.8-2.5 1.7-1 2.8-3-.3L12 21l-2.5-2-3 .3-1-2.8L3 13l1-2.8L3 7.4l2.5-1.7 1-2.8 3 .3L12 3z M9 12l2 2 4-4",
  // actions
  screen:  "M3 5h18v11H3z M8 20h8 M12 16v4",
  stop:    "M7 7h10v10H7z",
  clapper: "M3 8h18v11H3z M3 8l2-4h3l-2 4 M9 4h3l-2 4 M15 4h3l-2 4",
  tools:   "M14 6a3 3 0 00-4 4L4 16v4h4l6-6a3 3 0 004-4l-2 2-2-2 2-2z",
  folder:  "M3 6h6l2 2h10v11H3z",
  eye:     "M2 12s3.5-6 10-6 10 6 10 6-3.5 6-10 6-10-6-10-6z M12 9.5a2.5 2.5 0 100 5 2.5 2.5 0 000-5z",
  trash:   "M4 7h16 M9 7V4h6v3 M6 7l1 13h10l1-13",
  paperclip:"M20 11l-8 8a4 4 0 01-6-6l8-8a2.5 2.5 0 014 4l-8 8",
  link:    "M9 15l6-6 M10 7l1-1a4 4 0 016 6l-1 1 M14 17l-1 1a4 4 0 01-6-6l1-1",
  pencil:  "M4 20h4L19 9l-4-4L4 16v4z M14 6l4 4",
  hourglass:"M6 3h12 M6 21h12 M7 3c0 5 10 5 10 0 M7 21c0-5 10-5 10 0",
  save:    "M4 4h12l4 4v12H4z M8 4v5h7V4 M8 14h8v6H8z",
  mic:     "M12 3a3 3 0 00-3 3v5a3 3 0 006 0V6a3 3 0 00-3-3z M6 11a6 6 0 0012 0 M12 17v4 M9 21h6",
  lock:    "M6 10h12v10H6z M9 10V7a3 3 0 016 0v3",
  unlock:  "M6 10h12v10H6z M9 10V7a3 3 0 015.9-.8",
  download:"M12 3v12 M7 11l5 5 5-5 M4 20h16",
  camera:  "M3 7h4l2-2h6l2 2h4v13H3z M12 11a3.5 3.5 0 100 7 3.5 3.5 0 000-7z",
  plus:    "M12 5v14 M5 12h14",
  music:   "M9 18V5l11-2v13 M9 18a3 3 0 11-6 0 3 3 0 016 0z M20 16a3 3 0 11-6 0 3 3 0 016 0z",
  speaker: "M4 9h4l5-4v14l-5-4H4z M17 9a4 4 0 010 6 M19.5 7a7 7 0 010 10",
  scales:  "M12 3v18 M6 21h12 M12 6l-7 2 3 6a3 3 0 006 0l-3-6 M12 6l7 2-3 6a3 3 0 01-6 0l3-6",
  image:   "M3 5h18v14H3z M3 16l5-5 4 4 3-3 6 6 M8.5 9a1.5 1.5 0 100-3 1.5 1.5 0 000 3z",
  rerun:   "M20 11a8 8 0 10-2 6 M20 5v6h-6",
  sun:     "M12 7a5 5 0 100 10 5 5 0 000-10z M12 2v2 M12 20v2 M4 12H2 M22 12h-2 M5 5l1.5 1.5 M17.5 17.5L19 19 M19 5l-1.5 1.5 M6.5 17.5L5 19",
  moon:    "M20 14a8 8 0 01-10-10 8 8 0 1010 10z",
  bolt:    "M13 3L4 14h6l-1 7 9-11h-6l1-7z",
  // domains / agents
  doc:     "M6 3h9l3 3v15H6z M15 3v3h3 M9 12h6 M9 16h6",
  code:    "M9 8l-4 4 4 4 M15 8l4 4-4 4",
  target:  "M12 3a9 9 0 100 18 9 9 0 000-18z M12 8a4 4 0 100 8 4 4 0 000-8z M12 11.5a.5 .5 0 100 1 .5 .5 0 000-1z",
  shield:  "M12 3l8 3v6c0 5-4 8-8 9-4-1-8-4-8-9V6l8-3z M9 12l2 2 4-4",
  search:  "M11 4a7 7 0 100 14 7 7 0 000-14z M20 20l-4.3-4.3",
  rocket:  "M14 4c3 0 6 3 6 6l-7 7-5-5 7-7z M9.5 14.5l-3 3 M6 13c-2 1-2 5-2 5s4 0 5-2 M13.5 9.5a1.5 1.5 0 11-2.1 2.1 1.5 1.5 0 012.1-2.1z",
  users:   "M8 11a3 3 0 100-6 3 3 0 000 6z M2 20a6 6 0 0112 0 M16 5.2a3 3 0 010 5.6 M17 14a6 6 0 015 6",
  layers:  "M12 3l9 5-9 5-9-5 9-5z M3 13l9 5 9-5 M3 17l9 5 9-5",
  // arrows
  arrowRight: "M4 12h16 M14 6l6 6-6 6",
  arrowUpRight: "M7 17L17 7 M8 7h9v9",
  arrowDownLeft: "M17 7L7 17 M16 17H7V8",
  enter:   "M20 6v6a2 2 0 01-2 2H5 M9 10l-4 4 4 4",
};

const FILLED = { dot: true };

export default function Icon({ name, size = 16, stroke = 2, style, title, ...rest }) {
  const d = P[name];
  if (!d) return null;
  const filled = FILLED[name];
  const paths = d.split(" M").map((seg, i) => (i === 0 ? seg : "M" + seg));
  return (
    <svg
      viewBox="0 0 24 24"
      width={size}
      height={size}
      fill={filled ? "currentColor" : "none"}
      stroke={filled ? "none" : "currentColor"}
      strokeWidth={stroke}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden={title ? undefined : "true"}
      role={title ? "img" : undefined}
      focusable="false"
      style={{ display: "inline-block", verticalAlign: "-0.15em", flexShrink: 0, ...style }}
      {...rest}
    >
      {title ? <title>{title}</title> : null}
      {paths.map((p, i) => (
        <path key={i} d={p} />
      ))}
    </svg>
  );
}
